import { Card, CardBody, CardTitle } from "reactstrap";
import React, { useEffect, useState } from "react";

import Loading from "../../loader/loader";
import { getCardStatus } from "../../../service/user-verification-service";
import moment from "moment";

const NestDetails = ({
  registrationObject,
  id,
  verificationLoading,
  title,
  rejectReason,
}) => {
  const [status, setStatus] = useState();
  useEffect(() => {
    if (id) {
      getCardStatusLabel(id);
    }
  }, []);

  const getCardStatusLabel = (id) => {
    getCardStatus(id)
      .then((res) => {
        setStatus(res && res.data);
      })
      .catch((err) => {
        setStatus();
      });
  };
  return (
    <Card style={{ height: "96%" }}>
      <CardBody
        style={{ paddingTop: 20, paddingBottom: 56 }}
        className="next-details"
      >
        <CardTitle
          tag="h1"
          className="user-verification-header header-reg"
        >
          Employee Details
        </CardTitle>
        {verificationLoading ? (
          <div
            style={{
              minHeight: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loading />
          </div>
        ) : (
          <>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Name
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {registrationObject.fullName || null}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Nationality
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {registrationObject.nationality}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Date Of Birth
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {moment(registrationObject.dateOfBirth).format("DD-MM-YY") !==
                "Invalid date"
                  ? moment(registrationObject.dateOfBirth).format("DD-MM-YY")
                  : null || null}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Passport Number
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {registrationObject.passportNumber}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Company
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {registrationObject.company}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Card Status
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {status}
              </label>
            </div>
            {title === "Rejected User" && (
              <div className="mt-1 row">
                <label
                  className="form-control-label col-lg-5 col-md-5 rem-pad"
                  style={{ marginTop: "5px" }}
                >
                  Reason for Rejection
                </label>
                <label className="col-lg-0.5 col-md-0.5">:</label>
                <label
                  className="col-lg-6 col-md-6 rem-pad"
                  style={{ marginTop: "5px" }}
                >
                  {rejectReason}
                </label>
              </div>
            )}
          </>
        )}
      </CardBody>
    </Card>
  );
};
const EidDetails = ({ registrationEidDetails, verificationLoading }) => {
  return (
    <Card style={{ height: "96%" }}>
      <CardBody style={{ paddingTop: 20, paddingBottom: 23 }}>
        <CardTitle
          tag="h1"
          className="user-verification-header header-reg"
        >
          EID Details
        </CardTitle>
        {verificationLoading ? (
          <div
            style={{
              minHeight: "230px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loading />
          </div>
        ) : (
          <>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Name
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {(registrationEidDetails && registrationEidDetails.fullName) ||
                  "N/A"}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Nationality
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {(registrationEidDetails &&
                  registrationEidDetails.nationality) ||
                  "N/A"}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Date of Birth
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {moment(
                  (registrationEidDetails &&
                    registrationEidDetails.dateOfBirth) ||
                    "N/A"
                ).format("DD-MM-YY") !== "Invalid date"
                  ? moment(
                      (registrationEidDetails &&
                        registrationEidDetails.dateOfBirth) ||
                        "N/A"
                    ).format("DD-MM-YY")
                  : "N/A" || "N/A"}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                EID Number
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {(registrationEidDetails &&
                  registrationEidDetails.emiratesIdNumber) ||
                  "N/A"}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Expiry Date
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {moment(
                  (registrationEidDetails &&
                    registrationEidDetails.expiryDate) ||
                    "N/A"
                ).format("DD-MM-YY") !== "Invalid date"
                  ? moment(
                      (registrationEidDetails &&
                        registrationEidDetails.expiryDate) ||
                        "N/A"
                    ).format("DD-MM-YY")
                  : "N/A" || "N/A"}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Card number
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {(registrationEidDetails &&
                  registrationEidDetails.cardNumber) ||
                  "N/A"}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Gender
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {(registrationEidDetails && registrationEidDetails.gender) ||
                  "N/A"}
              </label>
            </div>
          </>
        )}
      </CardBody>
    </Card>
  );
};
const PassportDetails = ({ passportDetails, verificationLoading }) => {
  return (
    <Card style={{ height: "96%" }}>
      <CardBody style={{ paddingTop: 20, paddingBottom: 23 }}>
        <CardTitle
          tag="h1"
          className="user-verification-header header-reg"
        >
          Passport Details
        </CardTitle>
        {verificationLoading ? (
          <div
            style={{
              minHeight: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loading />
          </div>
        ) : (
          <>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                First Name
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {(passportDetails && passportDetails.firstName) || "N/A"}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Last Name
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {(passportDetails && passportDetails.surName) || "N/A"}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Passport Number
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {(passportDetails && passportDetails.passportNumber) || "N/A"}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Country
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {(passportDetails && passportDetails.country) || "N/A"}
              </label>
            </div>{" "}
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Gender
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {(passportDetails && passportDetails.gender) || "N/A"}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Date Of Birth
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {moment(
                  (passportDetails && passportDetails.dateOfBirth) || "N/A"
                ).format("DD-MM-YY") !== "01-01-01"
                  ? moment(
                      (passportDetails && passportDetails.dateOfBirth) || "N/A"
                    ).format("DD-MM-YY")
                  : "N/A" || "N/A"}
              </label>
            </div>
            <div className="mt-1 row">
              <label
                className="form-control-label col-lg-5 col-md-5 rem-pad"
                style={{ marginTop: "5px" }}
              >
                Date Of Expiry
              </label>
              <label className="col-lg-0.5 col-md-0.5">:</label>
              <label
                className="col-lg-6 col-md-6 rem-pad"
                style={{ marginTop: "5px" }}
              >
                {moment(
                  (passportDetails && passportDetails.expiryDate) || "N/A"
                ).format("DD-MM-YY") !== "01-01-01"
                  ? moment(
                      (passportDetails && passportDetails.expiryDate) || "N/A"
                    ).format("DD-MM-YY")
                  : "N/A" || "N/A"}
              </label>
            </div>
          </>
        )}
      </CardBody>
    </Card>
  );
};

export { NestDetails, EidDetails, PassportDetails };
